import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import moment from "moment";
import VaporAccordion from "../vapor/accordion";
import { VaporRangeDatePicker, VaporDatePicker } from "../vapor";
import DocumentNumberFilter from "./documentNumberFilter";
import DocumentAmountFilter from "./documentAmountFilter";
import CounterpartFilter from "./counterpartFilter";

const FilterDeadlines = props => {
  const {
    startDateFilter,
    setStartDateFilter,
    setDocumentDate,
    endDateFilter,
    setEndDateFilter,
    selectedCounterparts,
    setSelectedCounterparts,
    selectedDocumentNumbers,
    setSelectedDocumentNumbers,
    selectedDocumentAmounts,
    setSelectedDocumentAmounts,    
    dateError,
    inModal
  } = props;

  const [filterCounter, setFilterCounter] = useState(0);
  const [opened, setOpened] = useState(true);
  const [opened2, setOpened2] = useState(true);
  const [selectedDocumentAmountsToShow, setSelectedDocumentAmountsToShow] = useState([]);

  useEffect(() => {
    if (selectedCounterparts.length === 0 && filterCounter > 0) {
      setFilterCounter(filterCounter - 1);
    }
  }, [selectedCounterparts.length]);

  const renderDateFilterInAccordion = () => {
    return (
      <div>
        <VaporAccordion
          itemId="data"
          onChange={val => setOpened(val)}
          opened={opened}
          title={<FormattedMessage id="deadlines.deadlineDateColumn" />}
        >
          <div
            style={{
              display: "flex",
              gap: "85px",
              marginLeft: "40px",
              marginBottom: "10px"
            }}
          >
            <div>Da data *</div>
            <div>A data *</div>
          </div>
          {renderDatePicker()}
        </VaporAccordion>
      </div>
    );
  };

  const renderDateFilter = () => {
    return (
      <div>
        <div className="reconciliation-filterDeadline">
          <FormattedMessage id="deadlines.deadlineDateColumn" />
        </div>
        <div
          style={{
            display: "flex",
            gap: "85px",
            marginLeft: "40px",
            marginBottom: "10px"
          }}
        >
          <div>Da data *</div>
          <div>A data *</div>
        </div>
        {renderDatePicker()}
      </div>
    );
  };

  const renderDatePicker = () => {
    return (
      <div
        className={dateError ? "errorOccurs" : ""}
        style={{ marginLeft: "40px", position: "relative" }}
      >
        <VaporRangeDatePicker
          value={[
            startDateFilter ? moment(startDateFilter) : null,
            endDateFilter ? moment(endDateFilter) : null
          ]}
          onChange={e => {
            if (e && e.length !== 0) {
              if (startDateFilter === null && endDateFilter === null) {
                setFilterCounter(filterCounter + 1);
              }
              setStartDateFilter(e[0]?.format("YYYY-MM-DD"));
              setEndDateFilter(e[1]?.format("YYYY-MM-DD"));
            } else {
              setFilterCounter(filterCounter - 1);
            }
          }}
        />
      </div>
    );
  };

  const renderCounterpartFilterInAccordion = () => {
    return (
      <div>
        <VaporAccordion
          itemId="counterpart"
          onChange={val => setOpened2(val)}
          opened={opened2}
          title={<FormattedMessage id="generic.counterpart" />}
        >
          {renderCounterpart()}
        </VaporAccordion>
      </div>
    );
  };

  const renderCounterpartFilter = () => {
    return (
      <div style={{marginBottom:"45px"}}>
        <div className="reconciliation-filterDeadline">
          <FormattedMessage id="generic.counterpart" />
        </div>
        {renderCounterpart()}
      </div>
    );
  };

  const renderCounterpart = () => {
    return (
      <div style={{ marginLeft: "40px" }}>
        <CounterpartFilter
          filterCounter={filterCounter}
          setFilterCounter={setFilterCounter}
          selectedCounterparts={selectedCounterparts}
          setSelectedCounterparts={setSelectedCounterparts}/>
      </div>
    );
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginRight: "50px",
          marginTop: !inModal ? "30px" : "0px",
          marginBottom: inModal && "20px"
        }}
      >
        <div
          className="reconciliation-filterTitle"
          style={{ marginLeft: !inModal ? "40px" : "0px" }}
        >
          <FormattedMessage id="deadlines.reconciliation.filterTitle" />
        </div>
        {filterCounter > 0 && (
          <div className="filterCounter">Filtri ({filterCounter})</div>
        )}
      </div>
      {!inModal ? renderDateFilter() : renderDateFilterInAccordion()}
      {!inModal
        ? renderCounterpartFilter()
        : renderCounterpartFilterInAccordion()
      }
      {!inModal ?
        <>
          <h3 className="dbx-filter-deadlines-filter-title"><FormattedMessage id="generic.documentsData"/></h3>
          <div className="documents-filter-container">
            <div className="document-date-filter-container">
              <h4 className="document-filter-title"><FormattedMessage id="generic.documentDate"/></h4>
              <VaporDatePicker
                // defaultValue={moment()}
                // value={documentDate !== null ? moment(documentDate) : moment()}
                getPopupContainer={trigger => trigger.parentNode}
                onChange={e => {
                  setDocumentDate(moment(e)?.format("YYYY-MM-DD"));
                  setFilterCounter(filterCounter + 1);
                }}
              />
            </div>
            <DocumentNumberFilter
              filterCounter={filterCounter}
              setFilterCounter={setFilterCounter}
              selectedDocumentNumbers={selectedDocumentNumbers}
              setSelectedDocumentNumbers={setSelectedDocumentNumbers}/>
          </div>
          <DocumentAmountFilter
            filterCounter={filterCounter}
            setFilterCounter={setFilterCounter}
            selectedDocumentAmountsToShow={selectedDocumentAmountsToShow}
            setSelectedDocumentAmountsToShow={setSelectedDocumentAmountsToShow}
            selectedDocumentAmounts={selectedDocumentAmounts}
            setSelectedDocumentAmounts={setSelectedDocumentAmounts}
          />
        </>
        : null
      }
    </div>
  );
};

export default FilterDeadlines;
